import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { getCookie } from "../../../api/utils/utils";

const getGuestToken = (): string => {
  if (typeof window !== "undefined") {
    const sessionToken = sessionStorage.getItem("guest-token-chat");
    if (sessionToken) return sessionToken;
  }
  return (
    getCookie("guest-token-chat") ||
    getCookie("x-guest-token") ||
    getCookie("guest-token") ||
    ""
  );
};

export class SupportProvider {
  static async getChatbotTemplate() {
    return await $axios.get($api("chatbot_template"));
  }

  static async getChildChatbotTemplate(id: number) {
    return await $axios.get($api("chatbot_template_id", { id }));
  }

  static async postUserChatData(payload: any) {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const guestToken = getGuestToken();
    const params =
      !token && guestToken ? { guest_token: guestToken } : undefined;

    return await $axios.post($api("post_user_data"), payload, {
      params,
    });
  }

  static async sendMessage(id: number, payload: any) {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const guestToken = getGuestToken();
    const params =
      !token && guestToken ? { guest_token: guestToken } : undefined;

    return await $axios.post($api("send_message", { id }), payload, {
      params,
    });
  }

  static async getMessages() {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const guestToken = getGuestToken();
    const params =
      !token && guestToken ? { guest_token: guestToken } : undefined;

    return await $axios.get($api("get_messages"), {
      params,
    });
  }
}
